import '../../../styles/templates/metaobject/faqs.scss'
import { load } from '@shopify/theme-sections'
import '../../sections/section-faq-metaobject-display'
import '../../sections/index-hero-slider'
import '../../sections/section-enquire-form-v2'

load([
    `section-faq-metaobject-display`,
    `index-hero-slider`,
    `section-enquire-form-v2`
])

